import React from 'react'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { IParsedCV, ParsedOptionKind } from 'types/cvParserInterfaces'
import { isNewParsedOption, parsedOptionChoice } from 'utils/parsedProfileFields'

/** @notExported */
interface IParsedOptionStatusProps {
  /** Parsed CV */
  cv: IParsedCV
  /** Option kind */
  kind: ParsedOptionKind
  /** The item's names */
  names: string[]
}

/**
 * Next to a parsed skill, role or industry: "New" when saving would create an option for it, or the
 * existing option the reviewer chose instead
 *
 * @returns The mark, or nothing
 * @notExported
 */
const ParsedOptionStatus: React.FC<IParsedOptionStatusProps> = ({ cv, kind, names }) => {
  const { t } = useTranslation()
  const choice = parsedOptionChoice(cv, kind, names)

  if (choice) {
    return (
      <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>
        {`→ ${choice.name}`}
      </Typography>
    )
  }

  if (isNewParsedOption(cv, kind, names)) {
    return <Chip label={t('admin.parse.result.new')} size="small" color="warning" variant="outlined" sx={{ ml: 1 }} />
  }

  return null
}

export default ParsedOptionStatus
